import CardsInfoPage         from 'pages/CardsInfoPage';
import ErrorPage             from 'pages/ErrorPage';
import LoginPage             from 'pages/LoginPage';
import LogoutPage            from 'pages/LogoutPage';
import MassActivateCardsPage from 'pages/MassActivateCardsPage';
import OrderCardsPage        from 'pages/OrderCardsPage';
import ReportsPage           from 'pages/ReportsPage';
import ResetPasswordPage     from 'pages/ResetPasswordPage';
import RootRoute             from 'routing/RootRoute';

import { createBrowserRouter } from 'react-router-dom';

import internalPaths from './internalPaths';


const router = createBrowserRouter([
  {
    path:         "/",
    element:      <RootRoute/>,
    errorElement: <ErrorPage/>,
    children:     [
      {
        path:    internalPaths.login,
        element: <LoginPage/>,
      },
      {
        path:    internalPaths.resetPassword,
        element: <ResetPasswordPage/>,
      },
      {
        path:    internalPaths.cardsInfo,
        element: <CardsInfoPage/>,
      },
      {
        path:    internalPaths.orderCards,
        element: <OrderCardsPage/>,
      },
      {
        path:    internalPaths.massActivateCards,
        element: <MassActivateCardsPage/>,
      },
      {
        path:    internalPaths.reports,
        element: <ReportsPage/>,
      },
      {
        path:    internalPaths.logout,
        element: <LogoutPage/>,
      }
    ]
  },

]);

export default router;